import PropTypes from 'prop-types';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import { Button } from 'reactstrap';

const RemoveAccountError = ({ handleConfirmRemoveAccount }) => {
  const { t } = useTranslator();

  const {
    images: { removeAccountError },
  } = useAppContext();

  return (
    <div className="white-box text-center">
      <img src={removeAccountError} className="mb-l" alt="" />
      <p className="semi-bold mb-l">{t('deletingAccount.notification.errorOccured.title')}</p>
      <p className="mb-l">{t('deletingAccount.notification.errorOccured.content')}</p>
      <Button color="primary" className="w-100" onClick={handleConfirmRemoveAccount}>
        {t('deletingAccount.notification.errorOccured.retry.button')}
      </Button>
    </div>
  );
};

RemoveAccountError.propTypes = {
  handleConfirmRemoveAccount: PropTypes.func.isRequired,
};

export default RemoveAccountError;
